export default __webpack_public_path__ + "static/media/happy_to_help_slide_3.3650715f.png";